import { remotingReducers, remotingInitialStates, RemotingState } from '@lifesize/clients.remoting';
import appReducer, { initialState as appInitialState } from './app';
import GlobalState from '../constants/Types/GlobalState';

export const globalInitialState = {
  ...appInitialState,
  remoting: {
    controller: remotingInitialStates.controller,
    pairing: remotingInitialStates.pairing,
    wirelessPresentation: remotingInitialStates.wirelessPresentation
  }
};

const remotingReducer = (state: RemotingState, action: any) => {
  return {
    controller: remotingReducers.controller(state.controller, action),
    pairing: remotingReducers.pairing(state.pairing, action),
    wirelessPresentation: remotingReducers.wirelessPresentation(state.wirelessPresentation, action)
  };
};

export default function (state: GlobalState = globalInitialState, action: any) {
  return {
    ...appReducer(state, action),
    remoting: remotingReducer(state.remoting, action)
  };
}



// WEBPACK FOOTER //
// ./src/reducers/index.ts